import React from "react";
import { DateFormat, DateTimeFormat } from "../../helpers/utils";
import TableBase from "./Base";

const SpinTheWheelGamesTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Name",
			dataIndex: "name",
			width: 250,
			ellipsis: true,
		},
		{
			title: "Total Chances",
			dataIndex: "total_chances",
			width: 150,
			ellipsis: true,
		},
		{
			title: "Start Date",
			dataIndex: "start_date",
			width: 150,
			ellipsis: true,
			render(record) {
				return <span>{DateFormat(record)}</span>;
			},
		},
		{
			title: "End Date",
			dataIndex: "end_date",
			width: 150,
			ellipsis: true,
			render(record) {
				return <span>{DateFormat(record)}</span>;
			},
		},
		{
			title: "Redeem Expiry Date",
			dataIndex: "redeem_expiry_date",
			width: 150,
			ellipsis: true,
			render(record) {
				return <span>{DateFormat(record)}</span>;
			},
		},
		{
			title: "Updated At",
			dataIndex: "updated_at",
			width: 200,
			ellipsis: true,
			render(record) {
				return DateTimeFormat(record);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 50,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default SpinTheWheelGamesTable;
